<h2 mat-dialog-title>
  Files <span class="cd-title-label">· {{ data.contractLabel }}</span>
</h2>

<mat-dialog-content>
  <p class="br-small br-text-muted br-m-0" *ngIf="data.ownerName">{{ data.ownerName }}</p>

  <!-- One upload, the one the server takes: the contract's signed copy, as a
       PDF, a Word document or a picture of the paper. Storing it does not
       change the contract's status. -->
  <div class="cd-bar">
    <input #fileInput type="file" hidden [accept]="accept" (change)="onFileChosen($event)" />
    <button type="button" class="br-btn br-btn--primary br-btn--sm"
            [disabled]="uploading" (click)="fileInput.click()" data-test="document-upload">
      <br-icon>upload_file</br-icon> {{ uploading ? 'Uploading…' : 'Upload signed copy' }}
    </button>
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
            (click)="openContractPdf()" data-test="contract-pdf">
      <br-icon>picture_as_pdf</br-icon> View contract PDF
    </button>
    <span class="br-small br-text-muted">PDF, Word or image, up to 10 MB</span>
  </div>

  <div class="br-alert br-alert--danger cd-error" *ngIf="error" data-test="document-error">
    <br-icon>error_outline</br-icon><span>{{ error }}</span>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <table class="cd-table" *ngIf="documents.length">
    <thead>
      <tr>
        <th>File</th>
        <th>Kind</th>
        <th>Stored</th>
        <th class="cd-number">Size</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let stored of documents" data-test="document-row">
        <td class="cd-name">{{ stored.fileName }}</td>
        <td>{{ kind(stored) }}</td>
        <td>{{ stored.uploadedAt | date:'medium' }}</td>
        <td class="cd-number">{{ size(stored.byteSize) }}</td>
        <td class="cd-actions">
          <button type="button" class="br-btn br-btn--ghost br-btn--sm"
                  *ngIf="canOpen(stored)" (click)="open(stored)">Open</button>
          <button type="button" class="br-btn br-btn--ghost br-btn--sm"
                  (click)="download(stored)">Download</button>
        </td>
      </tr>
    </tbody>
  </table>

  <p class="br-small br-text-muted cd-empty" *ngIf="!loading && !documents.length && !error">
    No file is stored for this contract yet.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="br-btn br-btn--ghost" mat-dialog-close>Close</button>
</mat-dialog-actions>
